import { render } from "./VoteForNextWeek.vue?vue&type=template&id=bc29c30c"
import script from "./VoteForNextWeek.vue?vue&type=script&lang=js"
export * from "./VoteForNextWeek.vue?vue&type=script&lang=js"

import "./VoteForNextWeek.vue?vue&type=style&index=0&id=bc29c30c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__